import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';
import Hashids from 'hashids';


import RegisterForm from '../components/RegisterForm/RegisterForm.js'
import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'

var hashids = new Hashids('k100p');

const getUrlParams = () => {
  var urlParams;
  var match,
      pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1);

  urlParams = {};
  while (match = search.exec(query))
     urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
}

class Register extends Component {

  constructor(props){
    super(props);

    this.state = {
      intro: "Let's do this",
      tagline: "We're happy you're here."
    }
  }

  componentWillMount(){
    const { dispatch, user } = this.props;

    if(user.isLoggedIn){
      var urlParams = getUrlParams();
      if(urlParams.after){
        dispatch(push(window.atob(urlParams.after)));
      } else {
        dispatch(push('/'));
      }

    } else {

      var urlParams = getUrlParams();
      
      if(urlParams.in){
        this.setState({
          intro: window.atob(urlParams.in)
        })
      }

      if(urlParams.tg){
        this.setState({
          tagline: window.atob(urlParams.tg)
        })
      }

      if(urlParams.p){

        let id = window.atob(urlParams.p);
        console.log(id);
        if(isNaN(id)) id = hashids.decode(id)[0] + "";

        this.setState({
          cacheID: id 
        })
      }
    }
  }


  componentDidMount(){
    window.document.title = "Register - Pattycake";
  }


  render(){
    console.log(this.state);
    return <div className="body-stretch theme-light">
      <Header transparent={true}/>
      <div className="stretched">
        <div className="container">
          <div className="row justify-content-center row-mega-padded">
            <div className="col-md-4">
              <h1 className="text-center">
                {this.state.intro}
              </h1>
              <p className="lead text-center p-push-down">{this.state.tagline}</p>
              {
                this.state.cacheID &&
                <PatternThumbnail cacheID={this.state.cacheID} light={true} simple={true} official={true} noLink={true}/>
              }
              <RegisterForm/>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(Register);




// WEBPACK FOOTER //
// ./src/routes/Register.js